import { useReport, useReports } from "@/profitability/report-query";

/**
 * The template the page is about. The list holds active templates only, so
 * one that is not there (an archived template) is read by id: its own page
 * still opens, says it is archived and offers Restore.
 */
export const useTemplateReport = (
  businessId: string,
  reportId: string,
  /** Setup or Edit agent is open: keep reading it while Volca changes it. */
  watch = false,
) => {
  const reports = useReports(businessId);
  const listed = reports.data?.find((candidate) => candidate.id === reportId);
  // An agent still being set up, building, or holding a draft changes under
  // the page: it is read by id and kept fresh.
  const watching =
    watch ||
    (!!listed &&
      (!listed.published ||
        listed.draft_pending ||
        listed.build_status === "building"));
  const byId = useReport(
    businessId,
    reportId,
    watching || (reports.isSuccess && !listed),
    watching,
  );
  return {
    report:
      (watching ? (byId.data ?? listed) : (listed ?? byId.data)) ?? undefined,
    query: reports.isSuccess && !listed ? byId : reports,
  };
};
